import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { colors, defaultButtonSX } from '@src/styles';

interface ViewToggleProps {
  view: string;
  onViewChange: (event: React.MouseEvent<HTMLElement>, newView: string | null) => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({ view, onViewChange }) => {
  return (
    <ToggleButtonGroup
      value={view}
      exclusive
      onChange={onViewChange}
      aria-label="view switch"
      size="small"
      sx={{
        '& .MuiToggleButton-root': {
          ...defaultButtonSX,
          color: colors.primary.white,
          '&.Mui-selected': {
            backgroundColor: colors.primary.yellow,
            color: colors.background.primary,
            '&:hover': {
              backgroundColor: colors.primary.yellow,
              color: colors.background.primary,
            },
          },
          '&:not(.Mui-selected)': {
            '&:hover': {
              backgroundColor: 'rgba(255, 160, 21, 0.1)',
              color: colors.primary.yellow,
            },
          },
        },
      }}
    >
      <ToggleButton
        value="table"
        aria-label="table view"
        sx={{
          height: '32px',
          width: '108px',
        }}
      >
        Lista
      </ToggleButton>
      <ToggleButton
        value="groups"
        aria-label="groups view"
        sx={{
          height: '32px',
          width: '108px',
        }}
      >
        Grupos
      </ToggleButton>
      <ToggleButton
        value="analytics"
        aria-label="analytics view"
        sx={{
          height: '32px',
          width: '108px',
        }}
      >
        Análise
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
